import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { PublishedCanvasResult } from "./types";

const origin = environment.BACKEND_ORIGIN;

@Injectable({
    providedIn: "root",
})
export class CanvasApi {
    private http = inject(HttpClient);

    public getCanvas(canvasId: string) {
        return firstValueFrom(
            this.http.get<PublishedCanvasResult>(
                `${origin}/api/canvas/getPublishedCanvas`,
                {
                    params: { canvasId },
                }
            )
        );
    }
}
